__turbopack_context__.v({
  "className": "bebas_neue_9259b1dc-module__uPBKEG__className",
  "variable": "bebas_neue_9259b1dc-module__uPBKEG__variable",
});
